import config from '@/config/configClient.json?v=2.0';

export default function getClientConfig() {
  const hostname = window.location.hostname;
  return config[hostname] || config['localhost'];
}
